


function refreshContactForm () {

    if ($('#contact_lodger').length > 0) {
        console.log('L’élément existe.');
    } else {
        console.log('L’élément n’existe pas.');
        return;
    }

    var terms = '0';
    if($('#contact_lodger').prop('checked') == true)
    {
        terms = '1'
        $('#contact_agency').show();
    }
    else
    {
        $('#contact_agency').hide();
    }

    $.ajax({
        type: 'GET',
        url: '/json/contact/reason',
        contentType: "application/json",
        dataType: 'json',
        data: $.param({'terms' : terms}),
        success: function(data) {
            if (typeof data.results !== 'undefined') {
                var items = [];
                var terms = [];
                $('select#contact_reason :selected').each(function(){
                    terms.push($(this).val());
                });
                var $select = $('select#contact_reason');
                $select.empty();
                $select.append('<option value=""></option>');
                data.results.forEach(function(d){
                    var description = '';
                    var selected = '';
                    if ((d.description !== null) && (d.description !== '') ) {
                        description = ' toogle-title="' +  d.description + '"';
                    }
                    if (terms.indexOf(d.id) != -1 ) {
                        selected = ' selected';
                    }
                    $select.append('<option value="'+ d.id +'"' + description + selected + '>' + d.text + '</option>');

                });

                $select.select2();
            }
        },
        error: function(e) {
        }
    });


    $('.js-advanced-select').select2();
}

function refreshContactResidency() {
    var terms = [];
    $('select#contact_district :selected').each(function(){
        terms.push($(this).val());
    });
    terms = terms.join();

    $.ajax({
        type: 'GET',
        url: '/json/contact/residency',
        contentType: "application/json",
        dataType: 'json',
        data: $.param({'terms' : terms}),
        success: function(data) {
            if (typeof data.results !== 'undefined') {
                var terms = [];
                $('select#contact_residency :selected').each(function(){
                    terms.push($(this).val());
                });
                var $select = $('select#contact_residency');
                $select.empty();
                $select.append('<option value=""></option>');
                data.results.forEach(function(d){
                    var selected = '';
                    if (terms.indexOf(d.id.toString()) != -1 ) {
                        selected = ' selected';
                    }
                    $select.append('<option value="'+ d.id +'"' + selected + '>' + d.text + '</option>');

                });

                $select.select2();
            }
        },
        error: function(e) {
        }
    });
}


$(document).on('change.select2','select#contact_district',  function(){
    refreshContactResidency();
});


function contact() {
    if ($('form[name="contact"]').length) {
        $(document).on('click', '#contact_lodger', function() {
            refreshContactForm();
        });
        $(document).ajaxComplete(function (event, xhr, settings) {
            if (settings.url.includes('/ajax/contact')) {
                refreshContactForm();
                refreshContactResidency();
            }
        });
        refreshContactForm();
        refreshContactResidency();
    }
}

export default contact;
